export default __webpack_public_path__ + "volleyball-live.png";